const events = [
  {
    id: 1,
    title: "The Great Media Myth, and the New Playbook it Demands",
    date: "March 16, 2026",
    location: "Mumbai, India",
    description:
      "On 16th March, some of India’s most influential marketing, media, and research leaders gathered at the Jio World Convention Centre, Mumbai, for a landmark event that brought consumer truth to the forefront.",
    // ✅ REQUIRED FIELDS
    about: [
      "On 16th March, some of India’s most influential marketing, media, and research leaders gathered at the Jio World Convention Centre, Mumbai, for a landmark event that broke media myths, and brought some revealing consumer truths to the forefront.",
      "At the heart of the event was a powerful single-source study capturing the voices of over 12,000 Indian consumers. With exceptional precision, the study reveals how audiences consume media, what they trust, and what truly drives them to take action — offering a unified view of reach and engagement across platforms.",
      "This page is your gateway to everything from the event — capturing important moments, and presenting you with key highlights. You can also access the detailed reports and insights by downloading them from our website, thereby unlocking a deeper understanding of the findings that are shaping the future of media and marketing in India.",
    ],

    topics: [],

    reports: [
      {
        title:
          "The Great Media Myth & The New Playbook It Demands - Executive Summary",
        description: "",
        size: "2.09 MB",
        file: "https://inteliphyle.s3.ap-south-1.amazonaws.com/The_Great_Media_Myth_%26_The_New_Playbook_It_Demands-Executive_Summary.pdf",
      },
      {
        title:
          "The Great Media Myth & The New Playbook It Demands - Full Report",
        description: "",
        size: "95.7 MB",
        file: "https://inteliphyle.s3.ap-south-1.amazonaws.com/The_Great_Media_Myth_%26_The_New_Playbook_It_Demands-Full_Report.pdf",
      },
    ],
    videos: [
      {
        title: "Inteliphyle Unified Media View Study",
        url: "https://inteliphyle.s3.ap-south-1.amazonaws.com/INTELIPHYL.mp4",
      },
      {
        title: "Busting Myths with Inteliphyle",
        url: "https://inteliphyle.s3.ap-south-1.amazonaws.com/Myth+Video+270326.mp4",
      },
    ],
  },
];

export default events;
